import Helper from './helper';

export default {
    banks:{
        scb:{
            logo: function (){
                return Helper.logos.banks.getByCode("scb");
            }(),
            enName:"Siam Commercial Bank PCL.",
            thName:"ธนาคารไทยพาณิชย์ จำกัด (มหาชน)",
            code:"scb",
        },
        kbank:{
            logo: function (){
                return Helper.logos.banks.getByCode("kbank");
            }(),
            enName:"Kasikornbank PCL.",
            thName:"ธนาคารกสิกรไทย จำกัด (มหาชน)",
            code:"kbank",            
        },
        getByCode:function (code){
            return this[code];
        },
    }
}